function commentNode (el, vnode) {
  const comment = document.createComment(' ')

  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined
  })

  vnode.text = ' '
  vnode.elm = comment
  vnode.isComment = true
  vnode.context = undefined
  vnode.tag = undefined
  vnode.data.directives = undefined

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el)
  }
}

export default {
  install: function (Vue) {
    Vue.directive('beta', (el, binding, vnode) => {
      const inBeta = vnode.context.$store.state.beta.enabled
      const oldContent = !!binding.modifiers.oldContent // !! convert to boolean so later xor works
      let showElement = inBeta !== oldContent // xor

      if (!showElement) {
          commentNode(el, vnode)
      }
    })
  }
}
